var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-twitter';
                    var viewUrl = 'sprite.svg#view-icon-twitter';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };